import fallbackThumbnail from '../assets/images/barbershop.jpg';
import fallbackBarberThumbnail from '../assets/images/default-barber.jpg';
import fallbackShopBackground from '../assets/images/barber-hero.jpg';
import fallbackShopLogo from '../assets/images/squire-logo.svg';

const BOOKING_URL = '/book';

const getTemplateFolderByEnv = (env) => {
  switch (env) {
    case 'production':
      return 'prod';

    case 'staging':
    case 'qa':
      return 'staging';

    default:
      return 'dev';
  }
};

const config = {
  url: process.env.SQUIRE_API_URL || 'https://api-qa-1.getsquire.com/v1',
  stripeKey: process.env.SQUIRE_STRIPE_KEY || 'pk_test_WFMOwR069KZvJoKilYNKsQNR',
  branchKey: process.env.SQUIRE_BRANCH_KEY || 'key_test_lplOKGZFDRV1cTcCcVV6bihiBtj0z4Wt',
  fbPixel: process.env.FB_PIXEL_ID,
  squireShopUrl: process.env.NODE_ENV === 'production' ? 'app' : 'app-dev',
  emailTemplateFolder: getTemplateFolderByEnv(process.env.WEB_ENV),
  defaultTimezone: 'America/New_York',
  dateFormat: 'MM/DD/YYYY',
  apiDateFormat: 'YYYY-MM-DD',
  timeSlugFormat: 'YYMMDDHHmm',
  dateTimeFormat: 'MM/DD/YYYY hh:mm A',
  dateTimeFormatLong: 'MMMM Do [at] h:mm A',
  timeFormat: 'h:mm A',
  availableTimesFetchInterval: { weeks: 1 },
  nextAvailableTimeFetchInterval: {
    shop: { weeks: 1 },
    barber: { weeks: 4 },
  },
  pubnub: {
    subscribeKey: process.env.SQUIRE_PUBNUB_SUBSCRIBE_KEY || 'sub-c-b281b4c6-3f24-11e6-9baf-0619f8945a4f',
  },
  intercom: {
    appId: process.env.SQUIRE_INTERCOM_ID || 'fjhca6om',
  },
  googleMapsKey: process.env.SQUIRE_GOOGLE_MAPS_KEY || 'AIzaSyDLRFBhOTEMnT9sQyr-D_VQMByAU_yNpgs',
  googleAnalyticsID: process.env.SQUIRE_GOOGLE_ANALYTICS_ID || 'UA-73845752-1',
  fallbackShopThumbnail: fallbackThumbnail,
  fallbackServiceThumbnail: fallbackThumbnail,
  fallbackBarberThumbnail,
  fallbackShopBackground,
  fallbackShopLogo,
  urlPatterns: {
    old: '(/:shopRoute(/:barberRoute(/:serviceId(/:reservationTime))))',
    kiosk: '/kiosk(/:shopRoute(/:barberRoute(/:serviceId(/:reservationTime))))',
    booking: `(${BOOKING_URL}/:shopRoute)`,
    barber: `(${BOOKING_URL}/:shopRoute/professional(/:barberRoute(/:serviceId(/:reservationTime))))`,
    service: `(${BOOKING_URL}/:shopRoute/service(/:serviceId(/:barberRoute(/:reservationTime))))`,
    giftCard: '/gift-card/:shopRoute(/:barberRoute(/:giftCardAmount))',
    time: `(${BOOKING_URL}/:shopRoute/time(/:reservationTime(/:barberRoute(/:serviceId))))`,
  },
  bookingFallbackRedirects: [{
    from: `${BOOKING_URL}/:shopRoute/barber*`,
    to: `${BOOKING_URL}/:shopRoute/professional*`,
  }],
  defaultCurrency: 'USD',
  commanderUrl: process.env.COMMANDER_URL,
  firebase: {
    apiKey: 'AIzaSyDh_JBWohNL-Jw4RbKhhnNvpzXYHRcNX4g',
    authDomain: 'online-booking-71b81.firebaseapp.com',
    databaseURL: 'https://online-booking-71b81.firebaseio.com',
    projectId: 'online-booking-71b81',
    storageBucket: 'online-booking-71b81.appspot.com',
    messagingSenderId: '595855054393',
    appId: process.env.FIREBASE_APP_ID || '1:595855054393:web:f699847a2c4632ef4c5fe8',
    measurementId: process.env.FIREBASE_MEASUREMENT_ID || 'G-J0XN6Y0CBT',
  },
  analytics: {
    Mixpanel: {
      token: process.env.MIXPANEL_TOKEN || '1989ead379539857dd1bbafa3e37f7f7',
    },
  },
  fullstory: {
    url: 'https://api.fullstory.com',
    apiKey: process.env.SQUIRE_FULLSTORY_API_KEY,
    org: process.env.SQUIRE_FULLSTORY_ORG,
  },
  flagshipAppUrls: {
    android: process.env.FLAGSHIP_ANDROID_APP_URL || 'https://play.google.com/store/apps/details?id=com.getsquire.flagship',
    ios: process.env.FLAGSHIP_IOS_APP_URL || 'https://apps.apple.com/us/app/squire/id957644357',
  },
  payFacBrands: (process.env.PAYFAC_BRANDS || [
  ].join(',')).split(','),
  squireTokensUrl: process.env.SQUIRE_TOKENS_URL || 'https://squire-tokens-dev-1.getsquire.com',

  // prefix that is always attached to URLs for consolidated deployment
  pathPrefix: process.env.PUBLISH_URL ? process.env.PUBLISH_URL.split('.com')[1] : '',
  botProtection: {
    siteKey: process.env.SQUIRE_TURNSTILE_SITE_KEY,
  },
  launchDarkly: {
    clientSideId: process.env.SQUIRE_LD_CLIENT_SIDE_ID,
  },
};

export default config;



// WEBPACK FOOTER //
// ./src/config.js